import { apiClient } from './apiClient';
import { WFirmaCompanyAccount, AutoMapAccountsResponse } from '../types/wfirmaCompanyAccount';

export const wfirmaAccountService = {
  // Синхронизировать счета компании из wFirma
  syncCompanyAccounts: async (companyId: string): Promise<{ status: string; message: string }> => {
    const response = await apiClient.post(`/companies/${companyId}/wfirma/accounts/sync`);
    return response.data;
  },

  /** Удалить локальный кэш счетов wFirma (после смены интеграции); в wFirma ничего не удаляется */
  clearLocalWfirmaAccounts: async (
    companyId: string
  ): Promise<{ status: string; message: string; deletedCount: number }> => {
    const response = await apiClient.delete(`/companies/${companyId}/wfirma/accounts/local`);
    return response.data;
  },

  // Получить список счетов wFirma для компании
  getCompanyAccounts: async (companyId: string): Promise<WFirmaCompanyAccount[]> => {
    const response = await apiClient.get(`/companies/${companyId}/wfirma/accounts`);
    return response.data;
  },

  // Автоматически связать счета нашей системы со счетами wFirma
  autoMapAccounts: async (companyId: string): Promise<AutoMapAccountsResponse> => {
    const response = await apiClient.post(`/companies/${companyId}/wfirma/accounts/auto-map`);
    return response.data;
  },

  // Вручную связать счет нашей системы со счетом wFirma
  mapAccount: async (
    companyId: string,
    bankAccountId: string,
    wfirmaAccountId: string
  ): Promise<{ status: string; message: string }> => {
    const response = await apiClient.post(`/companies/${companyId}/wfirma/accounts/map`, {
      bankAccountId,
      wfirmaAccountId
    });
    return response.data;
  },

  // Удалить связь счета
  unmapAccount: async (
    companyId: string,
    bankAccountId: string
  ): Promise<{ status: string; message: string }> => {
    const response = await apiClient.delete(`/companies/${companyId}/wfirma/accounts/map/${bankAccountId}`);
    return response.data;
  },

  // Получить все связи счетов
  getMappings: async (companyId: string): Promise<Record<string, string>> => {
    const response = await apiClient.get(`/companies/${companyId}/wfirma/accounts/mappings`);
    return response.data;
  }
};
